<template>
  <AutoComplete
    v-model="inputValue"
    :label="label"
    :min-length="minLength"
    :name="name"
    :options="options"
    :theme="theme"
    :errors="errors"
    v-bind="$attrs"
    @blur="$emit('blur', $event)"
    @isSuggestionOpen="val => $emit('isSuggestionOpen', val)"
    @input="search"
  />
</template>

<script>
import AutoComplete from './AutoComplete'

export default {
  name: 'RemoteAutoComplete',

  components: {
    AutoComplete,
  },

  props: {
    callback: {
      type: Function,
      required: true,
    },
    errors: {
      type: Object,
      default: null,
    },
    debounce: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'autocomplete-field',
    },
    theme: {
      default: 'white',
      validator: theme => ['white', 'green', 'gray'].includes(theme),
    },
    minLength: {
      type: Number,
      default: undefined,
    },
    value: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    lastSearchTerm: null,
    inputValue: null,
    options: [],
    timeout: null,
  }),
  computed: {
    hasTooShortInput() {
      return this.minLength && this.inputValue.length < this.minLength
    },
  },
  watch: {
    inputValue: {
      handler(value) {
        this.$emit('input', value)
      },
      immediate: true,
    },
    value: {
      handler(value) {
        this.inputValue = value
      },
      immediate: true,
    },
  },

  methods: {
    search(term) {
      if (this.hasTooShortInput) {
        return
      }
      if (this.timeout !== null) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(() => {
        if (term !== this.lastSearchTerm) {
          this.lastSearchTerm = term
          this.callback(term).then(res => {
            this.options = res
          })
        }
      }, this.debounce)
    },
  },
}
</script>

<style scoped></style>
